import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import { Icon } from "./Icon";
import { type IconDataProps, iconDataSchema } from "./Icon.schema";
import type { IconName } from "./Icon.types";
import { ICON_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [ICON_TAG_NAME]: { props: IconDataProps; handle: undefined };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-icon": HTMLElement;
  }
}

function RWCIcon({ name, size }: IconDataProps): JSX.Element {
  return <Icon name={name as IconName} size={size} />;
}

componentManager.register(
  rwc(ICON_TAG_NAME, {
    component: RWCIcon,
    dataSchema: iconDataSchema,
  }),
);
